import React from 'react';
import './ComingSoon.css';

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <h4 className="coming-soon-title">Coming Soon</h4>
        <p className="coming-soon-text">Exciting Things Are on the Way-Stay Tuned!</p>

      </div>
    </div>
  );
};

export default ComingSoon;